import * as React from 'react'
import { observer } from 'mobx-react'
import LocalizationStore from '../../../../Stores/LocalizationStore'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import { Button } from 'react-bootstrap'
import { history } from '../../../../Routing'

@observer
export default class ExternalDataSearchByNameView extends React.Component<any> {
    constructor(props: any) {
        super(props)
    }

    ls = LocalizationStore.getInstance()

    schema: Object = {
        'type': 'object',
        'required': [
            'surname',
            'name'
        ],
        'properties': {
            'surname': {
                'title': this.ls.t('Enter surname'),
                'type': 'string'
            },
            'name': {
                'title': this.ls.t('Enter name'),
                'type': 'string'
            }
        }
    }

    submit(e: ISubmitEvent<any>) {
        history.push('/externalData/searchByName/' + e.formData['surname'] + '/' + e.formData['name'])
    }

    render() {
        const self = this
        let ls = LocalizationStore.getInstance()

        return (
            <div className="searchBlock">
                <Form
                    onSubmit={this.submit}
                    schema={self.schema}
                >
                    <div className="searchBtn">
                        <Button className="h-135" type="submit">{ls.t!('SearchBtn')}</Button>
                    </div>
                </Form>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/ExternalData/ExternalDataSearchViews/ExternalDataSearchByNameView.tsx